



























import { defineComponent } from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';
import { SfImage } from '../StorefrontUi';

export default defineComponent({
  name: 'HeaderSlide',
  components: {
    SfImage,
  },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { blok } = props;
    const iconUrl = blok.Icon && blok.Icon.filename;

    return {
      iconUrl,
      addBasePath,
    };
  },
});
